<template>
  <div id="app" style="width: 100%;height: 100%;">
    <router-view />
    <el-backtop :bottom="100"></el-backtop>

  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },


}
</script>

<style></style>
